export default "__VITE_ASSET__By96zphv__"